import React, {Component} from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import Resource from '../services/Resource';

class Template extends React.Component {

    constructor(props) {
        super(props);
        this.select = this.select.bind(this);
        this.isLoading = true;
        this.getTemplates().then(response => {
            let templates = response.map(template => {
                return {value: template.id, label: template.danishName}
            });
            this.setState({templates: templates, selected: templates[0]});
            this.isLoading = false;
            this.props.onSelectedTemplate(this.state.selected.value);
        })
    }

    async getTemplates() {
        let response = await fetch(Resource.prefix() +
            '/template/index');

        return await response.json();
    }

    select(selectedTemplate) {
        this.setState({selected: selectedTemplate});
        this.props.onSelectedTemplate(selectedTemplate.value);
    };

    render() {
        if (this.state !== null) {
            return (
                <div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label">Skabelon</label>
                        <div className="col-sm-10">
                            <Select
                                value={this.state.selected}
                                options={this.state.templates}
                                onChange={this.select}
                                isLoading={this.isLoading}
                                clearable={false}
                            />
                        </div>
                    </div>
                </div>
            );
        } else {
            return (<div></div>);
        }
    }
}

export default Template;


// WEBPACK FOOTER //
// ./web/src/components/Template.jsx